export const START = "_START";
export const SUCCESS = "_SUCCESS";
export const ERROR = "_ERROR";

export const AUTH = "AUTH";
export const ORDER_STATUS = "ORDER_STATUS";

